import React from 'react';
import {useSelector} from 'react-redux';

import * as S from './HotelDetails.styles';

import HotelName from './HotelName';
import RulesAndPolicies from './RulesAndPolicies';

import PriceNBookingButtonNPersuasion from '../PriceNBookingButtonNPersuasion';

import {isStaticDataLoading as isStaticDataLoadingSelectorFn} from '../../selectors';

import DetailsCardLoader from '../../../../../stories/components/hotels/Loadingpage/DetailCardLoader/DetailCardLoader';

export default function HotelDetails() {
  const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  if (isStaticDataLoading) {
    return <DetailsCardLoader />;
  }

  return (
    <S.DetailHotelInfoMainWrap>
      <PriceNBookingButtonNPersuasion />
      <S.HotelInfoTop>
        <HotelName />
        <RulesAndPolicies />
      </S.HotelInfoTop>
    </S.DetailHotelInfoMainWrap>
  );
}
